import request from '@/utils/request'

// 查询用户信息列表
export function listUser(query) {
  return request({
    url: '/biz/user/userList',
    method: 'get',
    params: query,
  })
}

// 查询用户信息分页
export function pageUser(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query,
  })
}

export function myTeam(query) {
  return request({
    url: '/inviteRecord/inviteRecord/myTeam',
    method: 'get',
    params: query,
  })
}

// 查询用户信息详细
export function getUser(data) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: data,
  })
}
// 查询用户信息详细
export function updateUserStatus(data) {
  return request({
    url: '/biz/user/updateUserStatus',
    method: 'put',
    data: data,
  })
}
export function authentication(data) {
  return request({
    url: '/biz/user/authentication',
    method: 'post',
    params: data,
  })
}
export function settingLevel(data) {
  return request({
    url: '/biz/user/settingLevel',
    method: 'post',
    data: data,
  })
}

// 更新用户开播权限
export function updateBroadcastPermission(data) {
  return request({
    url: '/biz/user/updateBroadcastPermission',
    method: 'post',
    data: data,
  })
}

// 新增用户信息
export function addUser(data) {
  return request({
    url: '/biz/user/add',
    method: 'post',
    data: data,
  })
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: '/biz/user/edit',
    method: 'post',
    data: data,
  })
}

// 删除用户信息
export function delUser(data) {
  return request({
    url: '/biz/user/delete',
    method: 'post',
    data: data,
  })
}

// 设置分销员助理
export function setDistributorAssistant(data) {
  return request({
    url: '/biz/user/setDistributorAssistant',
    method: 'post',
    data: data,
  })
}

// 取消分销员助理
export function cancelDistributorAssistant(data) {
  return request({
    url: '/biz/user/cancelDistributorAssistant',
    method: 'post',
    data: data,
  })
}

// 设置分销员
export function setDistributor(data) {
  return request({
    url: '/biz/user/setDistributor',
    method: 'post',
    data: data,
  })
}

// 取消分销员
export function cancelDistributor(data) {
  return request({
    url: '/biz/user/cancelDistributor',
    method: 'post',
    data: data,
  })
}

// 获取分销员助理列表
export function getDistributorAssistantList() {
  return request({
    url: '/biz/user/distributorAssistantList',
    method: 'get',
  })
}

// 获取分销员列表（用于选择上级分销员）
export function getDistributorList(excludeUserId) {
  return request({
    url: '/biz/user/distributorList',
    method: 'get',
    params: { excludeUserId },
  })
}

// 设置上级分销员
export function setSuperiorDistributor(data) {
  return request({
    url: '/biz/user/setSuperiorDistributor',
    method: 'post',
    data: data,
  })
}

// 批量创建用户拉卡拉分账接收方
export function applyLedgerReceiver(data) {
  return request({
    url: '/biz/user/applyLedgerReceiver',
    method: 'post',
    data: data,
  })
}

// 创建/变更用户拉卡拉分账接收方（单用户）
export function modifyLedgerReceiver(data) {
  return request({
    url: '/biz/user/modifyLedgerReceiver',
    method: 'post',
    data: data,
  })
}

// 查看用户分账关系绑定列表（含绑定店铺与绑定状态）
export function receiverBindList(params) {
  return request({
    url: '/biz/user/receiverBindList',
    method: 'get',
    params: params,
  })
}

// 重新提交分账关系绑定申请
export function reSubmitReceiverBind(data) {
  return request({
    url: '/biz/user/reSubmitReceiverBind',
    method: 'post',
    params: data,
  })
}
